import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import CoursesIndex from './views/courses/Index.vue';
import CoursesEntry from './views/courses/Entry.vue';
import CoursesLesson from './views/courses/lesson/Entry.vue';
import Login from './views/auth/Login.vue';
import Register from './views/auth/Register.vue';
import Faq from './views/Faq.vue';
import Contact from './views/Contact.vue';
// import Chat from './views/Chat.vue';

import Calendar from './views/Calendar.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Genex | Dashboard'
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        title: 'Genex | Calendar'
      }
    },
    // {
    //   path: '/chat',
    //   name: 'chat',
    //   component: Chat,
    //   meta: {
    //     title: 'Genex | Chat'
    //   }
    // },
    // {
    //   path: '/chat/:id',
    //   name: 'chat.channel',
    //   component: Chat,
    //   meta: {
    //     title: 'Genex | Chat'
    //   },
    //   props: true,
    // },
    {
      path: '/courses',
      name: 'courses',
      component: CoursesIndex,
      meta: {
        title: 'Genex | Courses'
      }
    },
    {
      path: '/courses/:courseId',
      name: 'courses.entry',
      component: CoursesEntry,
      props: true,
      meta: {
        title: 'Genex | Courses'
      }
    },
    {
      path: '/courses/:courseId/unit/:unitId/lesson/:lessonId',
      name: 'courses.lesson',
      component: CoursesLesson,
      meta: {
        title: 'Genex | Lesson'
      },
      props: true,
    },

    {
      path: '/canvas',
      name: 'canvas.index',
      meta: {
        title: 'Genex | Canvas'
      },
      component: () => import('./views/canvas/Index.vue'),
    },
    {
      path: '/canvas/:canvasId',
      name: 'canvas.view',
      props: true,
      meta: {
        title: 'Genex | Canvas'
      },
      component: () => import('./views/canvas/View.vue'),
    },

    {
      path: '/forum/:forumId',
      name: 'forum',
      props: true,
      meta: {
        title: 'Genex | Forum'
      },
      component: () => import('./views/Forum.vue'),
    },
    {
      path: '/forum/:forumId/topics/:topicId/post/:postId',
      name: 'forum.post',
      component: () => import('./views/forum/Post.vue'),
      props: true,
      meta: {
        title: 'Genex | Forum'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        title: 'Genex | Contact'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        title: 'Genex | FAQ'
      }
    },
    {
      path: '/login',
      name: 'auth.login',
      component: Login,
      meta: {
        title: 'Genex | Login'
      }
    },
    {
      path: '/register',
      name: 'auth.register',
      component: Register,
      meta: {
        title: 'Genex | Register'
      }
    },
    {
      path: '/e-studio',
      name: 'e-studio',
      component: () => import('./views/E-Studio.vue'),
      props: true,
      meta: {
        title: 'Genex | E-Studio'
      }
    },
    {
      path: '/e-studio/:documentId',
      name: 'e-studio.document',
      component: () => import('./views/E-Studio.vue'),
      props: true,
      meta: {
        title: 'Genex | E-Studio'
      }
    },
    {
      path: '/e-studio/project/:projectId',
      name: 'e-studio.project',
      component: () => import('./views/E-Studio.vue'),
      props: true,
      meta: {
        title: 'Genex | E-Studio'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        title: 'Genex | Profile'
      },
      component: () => import('./views/Profile.vue'),
    },
    {
      path: '/mentor',
      name: 'mentor',
      meta: {
        title: 'Genex | Mentors'
      },
      component: () => import('./views/mentor/Index.vue'),
    },
    {
      path: '/mentor/:mentorId',
      name: 'mentor.view',
      props: true,
      meta: {
        title: 'Genex | Mentor'
      },
      component: () => import('./views/mentor/View.vue'),
    },
    {
      path: '/students',
      name: 'students',
      component: () => import('./views/Students.vue'),
    },
    {
      path: '/students/projectreview/:studentName/:documentId',
      name: 'students.projectreview',
      component: () => import('./components/students/ProjectReview.vue'),
      props: true,
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('./views/Projects.vue'),
      meta: {
        title: 'Genex | Projects'
      }
    },
    {
      path: '/projects/:groupId/:userId/:projectId',
      name: 'projects.project',
      component: () => import('./components/projects/Project.vue'),
      props: true,
      meta: {
        title: 'Genex | Projects'
      }
    },
    {
      path: '/my-journal',
      name: 'my-journal',
      component: () => import('./views/Journal.vue'),
      meta: {
        title: 'Genex | Journal'
      }
    },
    {
      path: '/my-tasks',
      name: 'my-tasks',
      meta: {
        title: 'Genex | Tasks'
      },
      component: () => import('./views/Tasks.vue'),
    },
    {
      path: '/my-resources',
      name: 'my-resources',
      meta: {
        title: 'Genex | Resources'
      },
      component: () => import('./views/Resources.vue'),
    },
    {
      path: '/support',
      name: 'support',
      meta: {
        title: 'Genex | Support'
      },
      component: () => import('./views/Support.vue'),
    },
  ],
});